import React, { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover"
import { Button } from "components/ui/button"
import { cn } from "@/utils/shadcn-utils"
import { Settings } from "lucide-react"
import { Label } from "components/ui/label"
import {
  INVOICE_REDUCTION_BASE,
  INVOICE_REDUCTION_TYPE,
  InvoiceFormFields,
} from "@/constants/InvoiceConstants"
import { Control, Controller, UseFormRegister } from "react-hook-form"
import CustomSelectGroup from "components/common/selectGroup/CustomSelectGroup"
import { Input } from "components/ui/input"
import { ErrorMessage } from "@hookform/error-message"
import { Checkbox } from "components/ui/checkbox"
import { InvoiceFormType } from "@/types/InvoicesType"
import { reductionBaseOptions } from "@/constants/CodePromoConstants"

export interface InvoiceSettingsPopOverPropsType {
  control: Control,
  errors: any,
  register: UseFormRegister<InvoiceFormType>,
  watchReductionType : any,
  watchReductionBase : any,
  hasReduction : boolean,
  setHasReduction : (hasReduction: boolean) => void,
}

function InvoiceSettingsPopOver({
  control,
  errors,
  register,
  watchReductionType,
  watchReductionBase,
  hasReduction,
  setHasReduction
} : InvoiceSettingsPopOverPropsType) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id="settings"
          variant={"outline"}
          className={cn(" justify-start text-left font-normal")}>
          <Settings size={16} />
          Paramètres
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-4" align="end">
        <div className="w-[280px] flex flex-col space-y-4">
          {/*TVA*/}
          <div className="space-y-2">
            <Label htmlFor={InvoiceFormFields.tva}>TVA (%)</Label>
            <Controller
              name={InvoiceFormFields.tva}
              control={control}
              rules={{ required: "Veuillez sélectionner un client" }}
              render={({ field }) => (
                <CustomSelectGroup
                  name={InvoiceFormFields.tva}
                  id={InvoiceFormFields.tva}
                  value={field.value}
                  label="Choisir l’offre de l’entreprise"
                  items={[
                    { label: "18", value: "18.00" },
                    { label: "0", value: "0" },
                  ]}
                  onChange={(e: string) => field.onChange(e)}
                />
              )}
            />
            {/*<Input*/}
            {/*  id={InvoiceFormFields.tva}*/}
            {/*  type="number"*/}
            {/*  step="0.01"*/}
            {/*  min="0"*/}
            {/*  max="100"*/}
            {/*  {...register(InvoiceFormFields.tva)}*/}
            {/*  placeholder="0"*/}
            {/*/>*/}
          </div>

          <div className="flex space-x-2 items-center w-full">
            <Checkbox
              checked={hasReduction}
              id="hasReduction"
              onCheckedChange={(e) => {
                setHasReduction(e)
              }}
            />
            <Label htmlFor="hasReduction">Options de Réduction</Label>
          </div>
          {hasReduction && (
            <>
              {/*// Réduction base*/}
              <div className="space-y-2">
                <Label htmlFor={InvoiceFormFields.reductionBase}>
                  Base de réduction
                </Label>
                <Controller
                  name={InvoiceFormFields.reductionBase}
                  control={control}
                  rules={{
                    required: "La base de réduction est requise",
                    // validate: (value: string) => value.length !== 10 ?
                    //   "Format de date invalide" : ""
                  }}
                  render={({ field }) => (
                    <CustomSelectGroup
                      name={InvoiceFormFields.tva}
                      id={InvoiceFormFields.tva}
                      value={field.value}
                      label="Base de réduction"
                      items={reductionBaseOptions}
                      onChange={(e: string) => field.onChange(e)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name={InvoiceFormFields.reductionBase}
                  render={({ message }) => (
                    <p className="text-sm text-red-500">{message}</p>
                  )}
                />
              </div>

              {/*// Réduction type*/}
              <div className="space-y-2">
                <Label htmlFor={InvoiceFormFields.reductionType}>
                  Type de reduction
                </Label>
                <Controller
                  name={InvoiceFormFields.reductionType}
                  control={control}
                  rules={{ required: "Cette valeur est requise" }}
                  render={({ field }) => (
                    <CustomSelectGroup
                      name={InvoiceFormFields.reductionType}
                      id={InvoiceFormFields.reductionType}
                      value={field.value}
                      label="Choisir l’offre de l’entreprise"
                      items={[
                        { label: "Pourcentage", value: INVOICE_REDUCTION_TYPE.PERCENTAGE },
                        { label: "Fixe", value: INVOICE_REDUCTION_TYPE.FIXED },
                      ]}
                      onChange={(e: string) => field.onChange(e)}
                    />
                  )}
                />
              </div>

              {/*// Reduction Value*/}
              {
                watchReductionBase === INVOICE_REDUCTION_BASE.TOTAL &&
                  (<div className="space-y-2">
                    <Label htmlFor={InvoiceFormFields.reductionValue}>
                      Réduction (
                      {watchReductionType === INVOICE_REDUCTION_TYPE.PERCENTAGE ? "%" : "Fixe"})
                    </Label>
                    <Input
                      id={InvoiceFormFields.reductionValue}
                      type="number"
                      step="0.01"
                      min="0"
                      max={
                        watchReductionType === INVOICE_REDUCTION_TYPE.PERCENTAGE ? "100" : undefined
                      }
                      {...register(InvoiceFormFields.reductionValue)}
                      placeholder="0"
                    />
                  </div>)
              }
            </>
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default InvoiceSettingsPopOver